
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate/tab-loans",
      function () {
        return require("private-next-pages/affiliate/tab-loans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate/tab-loans"])
      });
    }
  